var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { PureComponent } from 'react';
import { SortOrder, TextAlignment, Unit } from '@philips-internal/oswald-ui-constants';
import { AwesomeComponent, ComponentType } from '@philips-internal/oswald-ui-core';
import { arrayOf, bool, color, element, eventListener, expression, formatters, oneOf, oneOfType, predefinedSize, record, string } from '@philips-internal/oswald-ui-core/lib/component/prop-types/index.js';
import { enumValues, isEqualShallow, isFunction } from '@philips-internal/oswald-ui-utils';
import { TableContext } from '../table-context.js';
import TableColumnAPI from './table-column-api.js';
import { ColumnType } from './table-column-constants.js';
const supportedAlignments = [
    TextAlignment.CENTER,
    TextAlignment.LEFT,
    TextAlignment.RIGHT,
];
const supportedColumnTypes = [
    ColumnType.CHECKBOX,
    ColumnType.DEFAULT,
    ColumnType.DYNAMIC,
    ColumnType.SUPERSCRIPTION,
    ColumnType.SUPERSCRIPTION_BAR,
];
let TableColumn = class TableColumn extends PureComponent {
    componentDidMount() {
        this.updateColumn();
    }
    componentDidUpdate(prevProps) {
        if (isEqualShallow(this.props, prevProps)) {
            return;
        }
        this.updateColumn();
    }
    componentWillUnmount() {
        if (isFunction(this.popColumn)) {
            this.popColumn();
        }
    }
    updateColumn() {
        if (!this.context) {
            throw new Error('[Component Context]: Context TableContext is not provided.');
        }
        this.popColumn = this.context.addOrUpdateColumn({ ...this.props, id: this.props.uuid });
    }
    render() {
        return null;
    }
};
TableColumn.contextType = TableContext;
TableColumn.propTypes = {
    alignment: oneOf(supportedAlignments),
    children: oneOfType([element, arrayOf(element)]),
    entry: string,
    formatters: formatters,
    headerAlignment: oneOf(supportedAlignments),
    id: string.notEnumerable(),
    onClick: eventListener,
    onContextMenuClick: eventListener,
    onDoubleClick: eventListener,
    onSort: eventListener,
    resizable: bool,
    showSuperscriptionLabel: bool,
    sortable: bool,
    sortDirection: oneOf(enumValues(SortOrder)),
    superscription: record({ color: color, icon: oneOfType([string, element]), label: string, value: string }),
    type: oneOf(supportedColumnTypes),
    value: expression,
    visible: bool,
    width: predefinedSize([Unit.PX, Unit.PERCENT]),
};
TableColumn.defaultProps = {
    alignment: TextAlignment.CENTER,
    headerAlignment: TextAlignment.LEFT,
    resizable: false,
    sortable: true,
    type: ColumnType.DEFAULT,
    value: 'Column',
    visible: true,
};
TableColumn = __decorate([
    AwesomeComponent({ api: TableColumnAPI, type: ComponentType.LIST })
], TableColumn);
export { TableColumn, };
export default TableColumn;
//# sourceMappingURL=table-column.js.map